export default __webpack_public_path__ + "static/media/Punto_Benvenuto_FRA_Def.991ae622.aac";